/** Internal tab id for Live Meeting Insights on MeetingDetailPage. */
export const MEETING_LIVE_INSIGHTS_TAB = 'controls'

/**
 * Resolve the meeting id to use for navigation (handles recurring child occurrences).
 * @param {object | string | null | undefined} meetingOrId
 * @returns {string | null}
 */
export function resolveMeetingId(meetingOrId) {
  if (meetingOrId == null) return null
  if (typeof meetingOrId === 'string') return meetingOrId
  return (
    meetingOrId.activeChildMeetingId ??
    meetingOrId.id ??
    meetingOrId.meetingId ??
    null
  )
}

/**
 * Path to the meeting detail page with Live Meeting Insights tab active.
 * @param {object | string | null | undefined} meetingOrId
 * @returns {string | null}
 */
export function getMeetingLiveInsightsPath(meetingOrId) {
  const meetingId = resolveMeetingId(meetingOrId)
  if (!meetingId) return null
  return `/meeting/${meetingId}?tab=${MEETING_LIVE_INSIGHTS_TAB}`
}
